import { useQuery } from '@tanstack/react-query';
import { getFinancesGames, queryKeys } from '@vgrubs/components';
import { GamesRange } from './gamesFormat';

/** What MyChips paid in the range and how it split. */
export const useGamesSummary = (range: GamesRange) => {
  const query = useQuery({
    queryKey: queryKeys.admin.financesGames.summary(range),
    queryFn: async () => (await getFinancesGames(range)).data.data,
  });

  return {
    summary: query.data ?? null,
    isLoading: query.isLoading,
    isError: query.isError,
  };
};
